export const FETCH_POSTS = 'FETCH_POSTS';
export const FETCH_DATA = 'FETCH_DATA';